import { CREATE_PROJECT, LIST_OF_PROJECT, PROJECT } from "./ApiRoutes";
import { authData } from "./services";

export const listOfProject = async (data: object) => {
  const response = await authData.post(LIST_OF_PROJECT, data);
  return response?.data;
};

export const createProject = async (data: object) => {
  const response = await authData.post(CREATE_PROJECT, data);
  return response?.data;
};

export const deleteProject = async (id: number) => {
  const response = await authData.delete(`${PROJECT}${id}`);
  return response?.data;
};

export const editProject = async (id: number, data: object) => {
  const response = await authData.put(`${PROJECT}${id}`, data);
  return response?.data;
};

export const viewProject = async (id: number) => {
  const response = await authData.get(`${PROJECT}${id}`);
  return response?.data;
};
